import React from "react";
import { MDBProgress } from "mdbreact";
import "../assets/css/styles.css";
import axios from "axios";
import DynamicUploadVideo from "./DynamicUploadVideo";
import { PopupModal } from "./PopupModal";
import { endPoint } from "../api";

class UploadVideo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videoUrl: "",
      filename: "",
      loaded: false,
      isLoading: false,
      baseUrl: `${endPoint}`,
      description: null,
      title: null,
      videoUploaded: false,
      details: {
        tags: [],
        filename: "",
        link: "",
        title: "",
        description: "",
        dynamic: true,
      },
      show: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.videoUploaded === true && this.state.videoUploaded === true) {
      this.setState({ videoUploaded: false, loaded: false });
    }
  }

  updateUserDetails = (user) => {
    console.log('updateUserDetails', user)
    // if (user) {
    //   axios
    //     .post(`${this.state.baseUrl}/user/${user._id}`, {
    //       ...user,
    //       visitCount: ++user.visitCount,
    //     })
    //     .then((res) => {
    //       console.log("res.data", res.data);
    //       window.localStorage.setItem("user", JSON.stringify(res.data));
    //       //this.handleClose()
    //       //this.onClickHandler();
    //       //this.setState({ videoUploaded: true });
    //     })
    //     .catch((error) => console.log("updateUserDetails",error));
    // }
  };

  handleFileChange = (e) => {
    const MAX_FILE_SIZE = 25;

    if (
      (e.target.files[0] !== undefined &&
        this.bytesToMB(e.target.files[0].size) <= MAX_FILE_SIZE &&
        e.target.files[0].type === "video/mp4") ||
      e.target.files[0].type === "video/quicktime"
    ) {
      this.setState({ filename: e.target.files[0] }, () => {
        this.onClickHandler();
      });
    } else {
      window.alert(
        "Max file size is 25MB and only mp4/mov file format is allowed"
      );
    }
  };

  bytesToMB = (bytes) => {
    return Math.round(bytes / Math.pow(1024, 2), 2);
  };

  onClickHandler = () => {
    //this.setState({ isLoading: true })
    window.localStorage.setItem("isActive", "upload");
    const data = new FormData();
    data.append("video", this.state.filename);

    axios
      .post(`${this.state.baseUrl}/upload/video`, data, {
        onUploadProgress: (ProgressEvent) => {
          //console.log('ProgressEvent.loaded',ProgressEvent.loaded);
          this.setState({
            loaded: Math.floor(
              (ProgressEvent.loaded / ProgressEvent.total) * 100
            ),
          });
        },
      })
      .then((res) => {
        this.setState({
          videoUploaded: true,
          details: {
            link: `${this.state.baseUrl}/upload/${res.data.filename}`,
            filename: res.data.filename,
            dynamic: true,
          },
        });

        const user = JSON.parse(window.localStorage.getItem("user"));
        this.updateUserDetails(user);
        // this.updateUserDetails()
        console.log("res", res);
      })
      .catch((err) => console.log(err));
  };

  // handleClose = () => {
  //   this.setState({ show: false });

  //   return this.props.history.push(`/`);
  // }
  // handleShow = () => this.setState({ show: false });

  render() {
    return (
      <div className="UploadVideo">
        <PopupModal
          // {...this.props}
          show={this.state.show}
          setUserDetails={this.setUserDetails}
          handleClose={this.handleClose}
          handleShow={this.handleShow}
        />

        {this.state.videoUploaded ? (
          <DynamicUploadVideo details={this.state.details} />
        ) : (
          <div className="UploadVideo_blk">
            <div className="uploadTopText">
              <div className="container">
                <div className="row">
                  <div className="col py-3 px-5 text-justify">
                    <p>
                      This demonstration of the value of our Mixie.ai engine
                      shows how you can easily extract valuable information from
                      your videos. After the sample file is uploaded and the
                      meta data is automatically extracted from a frame-by-frame
                      analysis of your video, the resulting information can
                      include object detection, face detection, sentiments
                      detection and location identification along with video
                      frame time stamp information.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="uploadVideoSec_blk">
                <div className="uploadContent">
                  <ul>
                    <li className="pb-5">
                      <div className="listIcon">
                        <div className="listIcon_blk bigIcon">
                          <svg
                            fill="#000"
                            height="10px"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 14.86 14.29"
                          >
                            <path d="M11.43,12.57a.58.58,0,0,0-.57-.57.57.57,0,0,0,0,1.14A.58.58,0,0,0,11.43,12.57Zm2.28,0a.57.57,0,0,0-.57-.57.57.57,0,0,0,0,1.14A.57.57,0,0,0,13.71,12.57Zm1.15-2v2.86a.87.87,0,0,1-.86.86H.86A.86.86,0,0,1,0,13.43V10.57a.86.86,0,0,1,.86-.86H4.67a1.72,1.72,0,0,0,1.62,1.15H8.57a1.73,1.73,0,0,0,1.62-1.15H14A.87.87,0,0,1,14.86,10.57ZM12,4.79a.58.58,0,0,1-.53.35H9.14v4a.57.57,0,0,1-.57.57H6.29a.57.57,0,0,1-.58-.57v-4H3.43a.58.58,0,0,1-.53-.35A.55.55,0,0,1,3,4.17l4-4A.52.52,0,0,1,7.43,0a.54.54,0,0,1,.4.17l4,4A.57.57,0,0,1,12,4.79Z" />
                          </svg>
                          {/* <img src="" alt="" className=""/> */}
                        </div>
                      </div>
                      <div className="contList">
                        Click on “drag/file to upload” and select a video file
                        from your device (video file should be a maximum of 25
                        Mb).
                      </div>
                    </li>
                    <li className="pb-5">
                      <div className="listIcon">
                        <div className="listIcon_blk bigIcon">
                          <svg
                            fill="#000"
                            height="10px"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 14 12.5"
                          >
                            <path d="M14,4.5a.47.47,0,0,1-.15.35l-4,4A.47.47,0,0,1,9.5,9,.51.51,0,0,1,9,8.5v-2H7.25c-3.37,0-5.58.65-5.58,4.38,0,.32,0,.64,0,1,0,.12,0,.26,0,.39a.25.25,0,0,1-.47.14,4.73,4.73,0,0,1-.29-.6A10,10,0,0,1,0,8.25a7.23,7.23,0,0,1,.41-2.6C1.5,3,4.69,2.5,7.25,2.5H9V.5A.51.51,0,0,1,9.5,0a.47.47,0,0,1,.35.15l4,4A.47.47,0,0,1,14,4.5Z" />
                          </svg>
                          {/* <img src="" alt="" className=""/> */}
                        </div>
                      </div>
                      <div className="contList">
                        Your video file will be uploaded to the Mixie.ai engine
                        and the file will be processed and the meta data
                        extraction will be done.
                      </div>
                    </li>
                    <li className="pb-4">
                      <div className="listIcon">
                        <div className="listIcon_blk bigIcon">
                          <svg
                            fill="#000"
                            height="10px"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 15.75 9.56"
                          >
                            <path d="M5.34,5.63a.75.75,0,0,1-.84-.85.74.74,0,0,1,.84-.84.75.75,0,0,1,.85.84A.75.75,0,0,1,5.34,5.63Zm2.54,0A.75.75,0,0,1,7,4.78a.75.75,0,0,1,.85-.84.74.74,0,0,1,.84.84A.75.75,0,0,1,7.88,5.63Zm2.53,0a.75.75,0,0,1-.85-.85.75.75,0,0,1,.85-.84.74.74,0,0,1,.84.84A.75.75,0,0,1,10.41,5.63Zm-5,3.69a.83.83,0,0,1-.6.24.85.85,0,0,1-.6-.24L.25,5.38A.8.8,0,0,1,0,4.78a.82.82,0,0,1,.25-.6L4.18.25A.82.82,0,0,1,4.78,0a.8.8,0,0,1,.6.25.82.82,0,0,1,.25.59.82.82,0,0,1-.25.6L2,4.78,5.38,8.12a.84.84,0,0,1,.25.6A.86.86,0,0,1,5.38,9.32Zm6.19,0a.85.85,0,0,1-.6.24.83.83,0,0,1-.6-.24.85.85,0,0,1-.24-.6.83.83,0,0,1,.24-.6l3.34-3.34L10.37,1.44a.81.81,0,0,1-.24-.6.81.81,0,0,1,.24-.59A.8.8,0,0,1,11,0a.82.82,0,0,1,.6.25L15.5,4.18a.82.82,0,0,1,.25.6.8.8,0,0,1-.25.6Z" />
                          </svg>
                          {/* <img src="" alt="" className=""/> */}
                        </div>
                      </div>
                      <div className="contList">
                        At the end of the processing, you will get:
                      </div>
                    </li>
                    <li className="subCont pb-3">
                      <div className="listIcon">
                        <div className="listIcon_blk smallIcon"></div>
                      </div>
                      <div className="contList">
                        A result of the video meta tags showing all the relevant
                        auto tagged elements of the video along with a time
                        stamp and the Mixie.ai engine’s recognition confidence
                        level.
                      </div>
                    </li>
                    <li className="subCont pb-2">
                      <div className="listIcon">
                        <div className="listIcon_blk smallIcon"></div>
                      </div>
                      <div className="contList">
                        A sample API code derived from the calls made to the
                        Mixie.ai engine.
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="uploadVideoSec">
                  <div className="vUpload">
                    <div className="UploadpageTitle mt-2 mb-2 ">
                      <h2>Upload your content and analyze</h2>
                    </div>
                    <div className="uploadIcon py-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="150"
                        viewBox="0 0 500.05 500.39"
                      >
                        <path d="M475.63,112.53c-7.75,34.33-38.45,61.12-75.09,61.12-29.78,0-55.62-18.07-68.43-42.87a29.64,29.64,0,0,1-8.13,1.27c-5.18,0-10-.4-14.23-2.72,12.44,34.41,50,63.9,90.79,63.9,48.13,0,88-36.46,95.31-82.58a28.11,28.11,0,0,1-20.22,1.88Z" />
                        <path d="M327.08,72.42c9.85-31.2,39.05-52.84,73.46-52.84,28.85,0,54,14.92,67.2,38.45a27.5,27.5,0,0,1,19.93-3.92C472.12,21.55,439,0,400.54,0c-48,0-86.51,31.69-95,79.69,5.12-4,11.48-7.59,18.48-7.59A29.06,29.06,0,0,1,327.08,72.42Z" />
                        <path d="M324,119a16.89,16.89,0,0,0,14.07-7.56h30.58l13,35.94a9.82,9.82,0,0,0,8.81,6.45h.4a9.78,9.78,0,0,0,8.89-5.7l31-67.47,4.86,7.73A9.52,9.52,0,0,0,444,93l10.75-.11,14.16-.13a17,17,0,1,0,1-19.6l-14.84.14-5.81.06L437.73,54.9A9.79,9.79,0,0,0,420.54,56l-28.61,62.24-7.23-20a9.81,9.81,0,0,0-9.21-6.46H337.36A16.78,16.78,0,0,0,324,85.16c-9.35,0-16.92,8.61-16.92,18S314.63,119,324,119Z" />
                        <path d="M206.47,194.34a9.07,9.07,0,0,0-4.73,8V365.83a9.08,9.08,0,0,0,14,7.64l127.18-81.76a9.08,9.08,0,0,0,0-15.28L215.73,194.67A9.1,9.1,0,0,0,206.47,194.34ZM219.9,219l101.29,65.11L219.9,349.19Z" />
                        <path d="M247.16,393.08A109,109,0,1,1,272.33,178c7.75-2.75,10.36-12.85,4.16-17.69a127.32,127.32,0,1,0,58.71,32c-7.36-1.89-15,6.07-12.57,13.12a109,109,0,0,1-75.47,187.64Z" />
                        <path d="M461.26,500.39H36.14l-1.6,0c-.56,0-1.12-.05-1.67-.1s-1.12-.09-1.67-.17-1.12-.14-1.67-.25A35.73,35.73,0,0,1,.12,467.48c0-.56-.09-1.12-.09-1.68s0-1.16,0-1.59V39.08c0-1.12.06-2.23.16-3.35a36.29,36.29,0,0,1,1.27-6.6A35.77,35.77,0,0,1,30.09,3.83c1.11-.16,2.22-.3,3.34-.36s2.33-.09,3.18-.08H312.8a7.71,7.71,0,0,1,2.85.49,7.36,7.36,0,0,1,4.61,5.74,7.08,7.08,0,0,1-.79,4.46,7.48,7.48,0,0,1-1.86,2.19,42.68,42.68,0,0,0-3.51,3.4,106.65,106.65,0,0,0-12.46,17,103.18,103.18,0,0,0-9.1,19,49.77,49.77,0,0,0-2.4,9.66l-.08.59a7.6,7.6,0,0,1-1.53,3.73,7.31,7.31,0,0,1-3.28,2.3,8.15,8.15,0,0,1-2.66.41H78.45a24.45,24.45,0,0,0-4.49.39A10.5,10.5,0,0,0,67.69,76,12.84,12.84,0,0,0,65,83a20.66,20.66,0,0,0-.18,2.27c0,.79,0,1.57,0,2.54v333l0,1.34c0,.38,0,.76,0,1.13a17.31,17.31,0,0,0,.55,4.11,8.48,8.48,0,0,0,3.79,5.33A18.16,18.16,0,0,0,77,435c.8.07,1.58.1,2.33.13H415.5a5.74,5.74,0,0,0,.63,0c.37,0,.69,0,1.1-.07a28.14,28.14,0,0,0,4.51-.73c5.76-1.52,8.25-4.58,8.76-10.59.06-.74.08-1.44.07-2.28s0-1.83,0-2.74V214.43a8.15,8.15,0,0,1,.18-2,7.19,7.19,0,0,1,5.75-5.53l.53-.1a50,50,0,0,0,9.34-3.23,144.11,144.11,0,0,0,18.8-10.27c3-1.94,6-4,8.85-6.11a83.31,83.31,0,0,0,8-6.67c.59-.57,1.15-1.15,1.66-1.71l.71-.83a6.92,6.92,0,0,1,4.82-2.53,7.1,7.1,0,0,1,4.15,1,7.43,7.43,0,0,1,3.68,6.13V463.82c0,.45,0,.91,0,1.51s0,1.11-.07,1.67a35.8,35.8,0,0,1-22.53,30.89A36,36,0,0,1,461.26,500.39Zm0-12a23.75,23.75,0,0,0,23.68-22.17c.09-1.33.05-3.36.06-5.2V182.91a4.75,4.75,0,0,0,.75,2.42,4.4,4.4,0,0,0,1.5,1.44,4.78,4.78,0,0,0,2.82.63,5.22,5.22,0,0,0,3.61-1.89l-1.1,1.29c-.74.82-1.48,1.58-2.23,2.31a93.53,93.53,0,0,1-9.17,7.68c-3.12,2.33-6.31,4.52-9.56,6.6a155.24,155.24,0,0,1-20.44,11.16,60.85,60.85,0,0,1-11.79,4l-.84.17a5.24,5.24,0,0,0,2.68-1.43,4.82,4.82,0,0,0,1.21-2.24c.18-1.19.09-1,.11-.62V418.49c0,1,0,1.82,0,2.86s0,2.19-.1,3.3a27.64,27.64,0,0,1-1.4,7,21.67,21.67,0,0,1-3.73,6.74,21.32,21.32,0,0,1-5.95,4.94,27.43,27.43,0,0,1-6.65,2.64,40.25,40.25,0,0,1-6.52,1.07c-.52.05-1.13.07-1.69.11a6.62,6.62,0,0,1-.76,0H79.25c-1.11,0-2.19-.08-3.26-.18A29.66,29.66,0,0,1,62.7,442.9,20.14,20.14,0,0,1,57,437.51a21.42,21.42,0,0,1-3.25-7,29.1,29.1,0,0,1-1-6.94c0-.57,0-1.12,0-1.67s0-1,0-1.46V87.85c0-.89,0-2,0-3a31.37,31.37,0,0,1,.26-3.3,28.65,28.65,0,0,1,1.64-6.82,21.57,21.57,0,0,1,3.9-6.6,20.58,20.58,0,0,1,6.19-4.81A25.41,25.41,0,0,1,71.74,61a36.81,36.81,0,0,1,6.65-.59h204.2a6.25,6.25,0,0,0-1.28.26,4.7,4.7,0,0,0-2.14,1.51,5.38,5.38,0,0,0-1,2.44l.11-.79a50,50,0,0,1,1.2-6.18c.5-2,1.1-3.94,1.75-5.85A115.41,115.41,0,0,1,291.36,30.5a117.57,117.57,0,0,1,14-19,54.27,54.27,0,0,1,4.54-4.38c.58-.47-.24,0-.91,1.2a4.94,4.94,0,0,0-.56,3.1,4.66,4.66,0,0,0,2.94,3.66,6.5,6.5,0,0,0,1.47.32H36.61c-1,0-1.64,0-2.41,0s-1.49.14-2.22.25A23.77,23.77,0,0,0,13,32.48a23.37,23.37,0,0,0-.84,4.38C12,37.6,12,38.35,12,39.1V464.21c0,.51,0,.82,0,1.21s0,.75.06,1.12a23.73,23.73,0,0,0,15.24,20.3A23.27,23.27,0,0,0,31.61,488c.36.07.73.12,1.1.17s.74.09,1.11.11a10.37,10.37,0,0,0,1.12.06c.39,0,.69,0,1.2,0H461.26Z" />
                      </svg>
                    </div>
                    <div className="dragText">
                      <p>Drag / Click to upload video</p>
                    </div>
                    <div className="btnrow">
                      <div className="fileselect">
                        <input
                          ref={(_fileInput) => (this.fileInput = _fileInput)}
                          type="file"
                          name="video"
                          accept="video/mp4"
                          onChange={this.handleFileChange}
                        />
                      </div>
                    </div>

                    <div className="newupload">
                      {this.state.loaded && (
                        <div className="nuStatus d-flex justify-content-between">
                          <span className="nuText">
                            {this.state.filename.name}
                          </span>
                          <b className="nuPer">{this.state.loaded}%</b>
                        </div>
                      )}

                      {this.state.loaded && (
                        <MDBProgress
                          material
                          value={this.state.loaded}
                          className="vtbProgress Progress progress"
                        >
                          {<span className="" />}
                        </MDBProgress>
                      )}
                    </div>
                  </div>
                  <div className="Note mt-2 mb-3">
                    <h2 className="Note mt-2 mb-3 text-center">
                      Upload only MP4/MOV file format and size should not be
                      greater than 25Mb
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default UploadVideo;
